import { api } from './Api';


export const uploadCsv = (blockUid: string, workspaceId: string, startTime: string, file: any, onProgress: (progressEvent: ProgressEvent) => void) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('block_uid', blockUid);
  formData.append('workspace_id', workspaceId);
  formData.append('start_time', startTime);

  return api.post(`code_block/upload_csv`, formData, {
    onUploadProgress: onProgress,
  })
    .then((res: any) => res.data);
}
